// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.102.1/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.102.1/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.aiiif-topbar {
    height: 40px;
    padding: 10px;
    background: linear-gradient(117deg,#fefefd,#fefefd 20%,#fafaf8 40%,#fafaf8);
    justify-content: center;
    display: flex;
    z-index: 1;
    width: 100%;
}

.aiiif-bar {
    display: flex;
    height: 40px;
    background-color: #f3f2f1;
    position: sticky;
    padding: 0 8px;
}

.aiiif-icon-button {
    margin: 0 6px;
    cursor: pointer;
    display: flex;
    vertical-align: middle;
    align-items: center;
    color: black;
    text-decoration: none;
}

.aiiif-icon-button  > svg {
    margin-right: 2px;
}
`, "",{"version":3,"sources":["webpack://./src/topBar/topbar.css"],"names":[],"mappings":"AAAA;IACI,YAAY;IACZ,aAAa;IACb,2EAA2E;IAC3E,uBAAuB;IACvB,aAAa;IACb,UAAU;IACV,WAAW;AACf;;AAEA;IACI,aAAa;IACb,YAAY;IACZ,yBAAyB;IACzB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,YAAY;IACZ,qBAAqB;AACzB;;AAEA;IACI,iBAAiB;AACrB","sourcesContent":[".aiiif-topbar {\n    height: 40px;\n    padding: 10px;\n    background: linear-gradient(117deg,#fefefd,#fefefd 20%,#fafaf8 40%,#fafaf8);\n    justify-content: center;\n    display: flex;\n    z-index: 1;\n    width: 100%;\n}\n\n.aiiif-bar {\n    display: flex;\n    height: 40px;\n    background-color: #f3f2f1;\n    position: sticky;\n    padding: 0 8px;\n}\n\n.aiiif-icon-button {\n    margin: 0 6px;\n    cursor: pointer;\n    display: flex;\n    vertical-align: middle;\n    align-items: center;\n    color: black;\n    text-decoration: none;\n}\n\n.aiiif-icon-button  > svg {\n    margin-right: 2px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
